import { useContext } from 'react'

import TrainingJourneyContext from 'contexts/TrainingJourneyContext'

const useTrainingJourney = () => {
  const context = useContext(TrainingJourneyContext)

  if (context === undefined) {
    throw new Error(
      'useTrainingJourney must be used within TrainingJourneyContext.Provider',
    )
  }

  return {
    accessType: context.accessType,
    activeStep: context.activeStep,
    company: context.company,
    formData: context.formData,
    handleNext: context.handleNext,
    linkInvalid: context.linkInvalid,
    loginMode: context.loginMode,
    portalToken: context.portalToken,
    setActiveStep: context.setActiveStep,
    setFormData: context.setFormData,
  }
}

export default useTrainingJourney
